// React
import { FormLabel, MenuItem } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
// Components
import CKeditor from 'ckeditor4-react';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';
// Import FilePond styles
import "filepond/dist/filepond.min.css";
import { DatePicker } from 'material-ui-pickers';
import * as React from 'react';
// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
// Redux
import { connect } from 'react-redux';
import { MethodRequest_e, NetworkManager } from '../managers/NetworkManager';
// MainStore
import { MainStore } from '../stores/MainStore';

// Register the plugin
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageCrop, FilePondPluginImageResize, FilePondPluginImageTransform);

interface State {
  filesOnServer: any;
  errors: Array<any>;
  product: any;
  users: any;
  date: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  isFinished: boolean;
  isUpdating: boolean;
  firstname: any;
  lastname: any;
  email: any;
  phone: any;
  title: any;
  order: any;
  toLocation: any;
  toDate: Date | null;
  src: any;
  crop: any;
  type: number;
  croppedImageUrl: any;
  profile_pic: any;
  croppedImage: any;
  text: string;
  textUpdated: string;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class RealisazionProfile extends React.Component<Props, State> {

  imageRef: null;

  private pond: any;

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      crop: {
        unit: "%",
        width: 30,
        height: 30,
        aspect: 4/3
      },
      filesOnServer: [],
      date: this.formatDate(new Date()),
      croppedImage: null,
      croppedImageUrl: null,
      email: "",
      employee: "",
      errors: [],
      files: "",
      firstname: "",
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      lastname: "",
      order: 1,
      phone: "",
      product: "",
      profile_pic: "",
      products: [],
      src: null,
      title: "",
      type: 1,
      toDate: null,
      toLocation: "",
      text: "",
      textUpdated: "",
      users: []
    };
  }

  formatDate = (date: any) => {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1).toString();
    let day = '' + d.getDate().toString();
    const year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

  async componentWillMount() {
    if (this.state.isUpdating) {
      await NetworkManager.request(`realization/${this.props.match.params.id}`, MethodRequest_e.GET).then((realization) => {
        this.setState({
          title: realization.title,
          date: realization.date,
          type: ~~realization.type,
          text: realization.description
        });
      });
      await NetworkManager.request(`realization/details/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
        this.setState({
          filesOnServer: Object.values(result.pictures)
        });
      });
    }
  }

  padLeft(originalString: string, length: number, character: string): string {
    const numberChars: number = length - originalString.length;
    let completedString = originalString;

    //Iterate to add the number of specific character
    for (let i = 0; i < numberChars; i++) {
      completedString = character + completedString;
    }

    return completedString;
  }

  handleChange = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.value } as any);
    };
  }

  handleChangeSelect = (name: string): any => (value: string) => {
    this.setState({
      [name]: value
    } as any);
  }

  handleChangeCheck = () => {
    return (event: React.ChangeEvent<any>) => {
      const key = event.target.name;
      this.setState({ [key]: event.target.checked } as any);
    };
  }

  handleFromDateChange = (date: Date) => {
    this.setState({ fromDate: date });
  }

  handleToDateChange = (date: Date) => {
    this.setState({ toDate: date });
  }

  handleFile = (e: any) => {
    const fileReader = new FileReader();
    fileReader.onloadend = () => {
      this.setState({ src: fileReader.result });
    };
    fileReader.readAsDataURL(e.target.files[0]);
  }

  onImageLoaded = (image: any) => {
    this.imageRef = image;
  }

  onCropChange = (crop: any) => {
    this.setState({ crop });
  }

  onCropComplete = (crop: any) => {
    if (this.imageRef && crop.width && crop.height) {
      const croppedImageUrl = this.getCroppedImg(this.imageRef, crop);
      this.setState({ croppedImageUrl });
    }
  }

  deletePicture = (item: any) => {
    return async (event: React.MouseEvent<any>) => {
      NetworkManager.request(`gallery/upload/${this.props.match.params.id}`, MethodRequest_e.DELETE, {
        filename: item
      });
      const array = [...this.state.filesOnServer]; // make a separate copy of the array
      const index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({ filesOnServer: array });
      }
    };
  }

  getCroppedImg(image: any, crop: any) {
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
    canvas.height = crop.height;
    const ctx: any = canvas.getContext("2d");

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    const reader = new FileReader();
    canvas.toBlob((blob: any) => {
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        this.setState({ croppedImage: reader.result });
      };
    }, "image/jpeg");
  }

  dataURLtoFile(dataurl: any, filename: any) {
    const arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    const croppedImage = new File([u8arr], filename, { type: mime });
    this.setState({ croppedImage: croppedImage });
  }

  checkUserValues = () => {
    return async (event: React.MouseEvent<any>) => {
      const errors: any = [];

      if (this.state.title == "") {
        errors['title'] = "Ajouter un titre";
      }

      this.setState({ errors: errors });

      const errorsNumber = Object.keys(errors).length;

      if (errorsNumber == 0) {
        MainStore.showOverlay(`${this.state.isUpdating ? "Modification" : "Création"} du fournisseur en cours...`);

        try {
          await NetworkManager.request(
            `realization${this.state.isUpdating ? `/${this.props.match.params.id}` : ""}`,
            this.state.isUpdating ? MethodRequest_e.PUT : MethodRequest_e.POST, {
            title: this.state.title,
            date: this.state.date,
            type: this.state.type,
            description: this.state.textUpdated
          }).then((response) => {
            if (this.state.croppedImage != null) {
              NetworkManager.request(`image/realization/${response.id}_cover`, MethodRequest_e.POST, {
                image: this.state.croppedImage
              });
            }
            MainStore.showNotification(response.text);
            MainStore.goBack(this.props.history.location.pathname);
            this.props.history.goBack();
          });
        } catch (error) {
          MainStore.showNotification(error.text, "bg-col-error");
          const newErrors = {};
          newErrors[error.state] = error.text;
          this.setState({
            errors: newErrors
          } as any);
        } finally {
          MainStore.hideOverlay();
        }
      }
    };
  }

  handleMainImageChange = (e: any) => {
    e.preventDefault();

    const reader = new FileReader();
    const file = e.target.files[0];

    reader.onloadend = () => {
      this.setState({
        files: file,
        image: reader.result
      });
    };

    reader.readAsDataURL(file);
  }

  addDefaultSrc = (ev: any) => {
    ev.target.className = 'hide';
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const id = this.props.match.params.id;
    const _this = this;
    return (
      <Paper elevation={1} className="form-paper-container" >
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          {this.state.isUpdating ? "Modification" : "Création"} d'un fournisseur</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <TextField
              label="Titre"
              name="title"
              value={this.state.title}
              error={Boolean(this.state.errors['title'])}
              helperText={this.state.errors['title']}
              fullWidth={true}
              onChange={this.handleChange()}
            />
          </Grid>
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <DatePicker
              label="Date"
              name="date"
              format="DD.MM.YYYY"
              value={this.state.date}
              error={Boolean(this.state.errors['date'])}
              helperText={this.state.errors['date']}
              fullWidth={true}
              onChange={(date) => { this.setState({ date: date }); }} />
          </Grid>
          <Grid item={true} xs={12} className="form-field">
            <CKeditor name="editor-article" onBeforeLoad={(CKEDITOR: any) => (CKEDITOR.disableAutoInline = true)}
              data={this.state.text} onChange={(evt: any) => this.setState({ textUpdated: evt.editor.getData() })} />
          </Grid>
          <Grid item={true} xs={12} md={6} xl={4} className="form-field">
            <TextField
              name="type"
              select={true}
              label="Catégorie"
              value={this.state.type}
              onChange={this.handleChange()}
              error={Boolean(this.state.errors['type'])}
              helperText={this.state.errors['type']}
              fullWidth={true}
            >
              {["Parquets", "PVC/Vynile/LVT", "Moquettes", "Rideaux"].map((category: any, key: number) => {
                return <MenuItem value={key + 1} key={key + 1}>{category}</MenuItem>;
              })}
            </TextField>
          </Grid>
          <Grid item={true} xs={12} md={12} xl={8}>
            <FormLabel>Image principale</FormLabel><br/><br/>
            <input type='file' id='profile_pic' value={this.state.profile_pic}
              onChange={this.handleFile} />
            {this.state.src && (
              <ReactCrop
                src={this.state.src}
                crop={this.state.crop}
                onImageLoaded={this.onImageLoaded}
                onComplete={this.onCropComplete}
                onChange={this.onCropChange}
              />
            )}
          </Grid>
          <Grid item={true} xs={12} md={12} lg={8}>
            <img onError={this.addDefaultSrc}
              src={`${NetworkManager.getApiServer()}/img/realization/${this.props.match.params.id}_cover.jpg`} />
          </Grid>

          <Grid item={true} xs={12} className="form-field">
            <FilePond
              ref={(ref: any) => (this.pond = ref)}
              files={this.state.files}
              allowMultiple={true}
              imageResizeTargetHeight={1440}
              imageTransformOutputMimeType={'image/jpeg'}
              imageTransformOutputQuality={85}
              imageResizeUpscale={false}
              onprocessfile={(error: any, file: any) => {
                this.setState((prevState: State) => ({
                  filesOnServer: [...prevState.filesOnServer, `${file.serverId}.jpg`]
                }));
                this.pond.removeFile(file.id);
              }}
              onupdatefiles={(fileItems: any) => {
                // Set currently active file objects to this.state
                this.setState({
                  files: fileItems.map((fileItem: any) => fileItem.file)
                });
              }}
              server={`${NetworkManager.getApiServer()}/realization/upload/${this.props.match.params.id}`}
            />
          </Grid>
          <Grid container={true} spacing={16} className="form-container">
          {this.state.filesOnServer.map(function (item: any, i: any) {
            const src = `${NetworkManager.getApiServer()}/img/realization/${id}/thumbnail/${item}`;
            return (
              <Grid item={true} xs={6} md={4} lg={2} xl={2} key={i} className="form-field">
                <img src={src} alt={`Image ${i}`} />
                <Button variant="raised" color="secondary" className=" square"
                  onClick={_this.deletePicture(item)}>
                  Supprimer
                </Button>
              </Grid>
            );
          })}
        </Grid>
        </Grid>
        <Button variant="contained" className="button-add square" onClick={this.checkUserValues()}>
          {this.state.isUpdating ? "Modifier" : "Créer"}
        </Button>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/RealizationProfile.tsx